import { promotions } from '@/mocks/yihao';

export default function PromotionSection() {
  return (
    <section className="w-full px-6 md:px-10 py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-900 mb-4">热门活动</h2>
          <p className="text-foreground-600 text-base max-w-2xl mx-auto">
            丰厚奖励和限时优惠，让您的娱乐之旅更加精彩。定期更新，敬请关注。
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {promotions.map((promo) => (
            <article key={promo.id} className="group relative rounded-xl overflow-hidden cursor-pointer h-[340px]">
              <img
                src={promo.image}
                alt={promo.title}
                title={promo.title}
                className="absolute inset-0 w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
              />
              <div className={`absolute inset-0 bg-gradient-to-t ${promo.color}`}></div>
              <div className="absolute inset-0 flex flex-col justify-end p-6">
                <span className="inline-block px-3 py-1 rounded-full bg-white/20 backdrop-blur-sm text-white text-xs font-medium w-fit mb-3">
                  {promo.tag}
                </span>
                <h3 className="text-white font-heading font-bold text-xl mb-2">{promo.title}</h3>
                <p className="text-white/85 text-sm leading-relaxed">{promo.description}</p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}